// FlowSettings.jsx
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { SelectInput, NumberInput } from '../Inputs/Inputs'

import styles from '../../../../css/devicePage.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const options = {
  flowUnits: [
    { value: 'gallons', name: 'Gallons' },
    { value: 'liters', name: 'Liters' },
  ],
  pulse: [
    { value: 1, name: 'On' },
    { value: 0, name: 'Off' },
  ],
}

const FlowSettings = ({ device }) => {
  const defaultSettings = {
    settings: {
      pulse: 0,
    },
  }

  const {
    physical: {
      flowUnits,
      unitsPerPulse,
    } = {},
    application_settings: applicationSettings = defaultSettings,
    application_settings_new: applicationSettingsNew = defaultSettings,
  } = device || {}

  const {
    settings: {
      pulse = 0,
    } = {},
  } = applicationSettings

  const {
    settings: {
      pulse: newPulse,
    } = {},
  } = applicationSettingsNew

  const [flowUnitsState, setFlowUnitsState] = useState(flowUnits)
  const [unitsPerPulseState, setUnitsPerPulseState] = useState(unitsPerPulse)
  const [pulseState, setPulseState] = useState(Number(newPulse == 0 || newPulse == 1 ? newPulse : pulse))

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        flowUnits: flowUnitsState,
        unitsPerPulse: unitsPerPulseState,
      },
    })

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: {
        address: device.address,
        status: 'new',
        settings: {
          pulse: Number(pulseState),
        },
      },
    })
  }, [flowUnitsState, unitsPerPulseState, pulseState, device.address])

  useEffect(() => {
    appDispatch()
  }, [flowUnitsState, unitsPerPulseState, pulseState, device])

  const handleChange = useCallback((field, value, callback) => {
    if (field === 'flowUnits') {
      setFlowUnitsState(value)
    } else if (field === 'unitsPerPulse') {
      setUnitsPerPulseState(value)
    } else if (field === 'pulse') {
      setPulseState(value)
    }
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          Units Per Pulse
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <NumberInput
            value={unitsPerPulseState}
            field='unitsPerPulse'
            childChange={childChange}
            style={styles.settingSelectInput}
          />
        </div>

        <h5>
          Flow Units
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={flowUnitsState}
            field='flowUnits'
            childChange={childChange}
            options={options.flowUnits}
            style={styles.settingSelectInput}
          />
        </div>

        <h5>
          Pulse Mode
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={pulseState}
            field='pulse'
            childChange={childChange}
            options={options.pulse}
            style={styles.settingSelectInput}
          />
        </div>
      </section>
    </div>
  )
}

FlowSettings.propTypes = {
  device: PropTypes.object.isRequired,
}

export default FlowSettings
